import { z } from 'zod';
import { isArrayValuesUnique } from '../../../utils/validators.js';
import { ErrorTypes } from '../../../utils/constants.js';
import { baseStructureSchema, baseSettingsSchema } from './base.structure.js';
import { blockSchema } from './block.js';

const msqStructureSchema = baseStructureSchema.extend({
  query: blockSchema.refine((query) => {
    const hasMedia = query.media?.length > 0;
    if (hasMedia) {
      return true;
    }
    if (!query.text) {
      return false;
    }
    const regex = /<[^>]+>/g;
    const cleanedText = query.text.replace(regex, "").trim();
    const hasLatex = query.text.includes("<katex");
    return cleanedText.length > 0 || hasLatex;
  }, {
    message: ErrorTypes.EMPTY_QUERY
  }),
  answer: z.array(z.number()).min(0, {
    message: ErrorTypes.INVALID_ANSWER
  }).max(5, {
    message: ErrorTypes.INVALID_ANSWER
  }),
  options: z.array(blockSchema).min(2, {
    message: ErrorTypes.MIN_OPTIONS
  }).max(5, {
    message: ErrorTypes.MAX_OPTIONS
  }),
  settings: baseSettingsSchema
}).refine((structure) => {
  if (!structure.settings.hasCorrectAnswer) {
    return structure.answer.length === 0;
  }
  if (structure.answer.length < 1) {
    return false;
  }
  return isArrayValuesUnique(structure.answer) && structure.answer.every((value) => value >= 0 && value < structure.options.length);
}, {
  message: ErrorTypes.INVALID_ANSWER
});

export { msqStructureSchema };
